import Joi from 'joi';

export const patientCreateValidator = (payload: unknown) => {
  const obj = Joi.object().keys({
    userData: {
      title: Joi.string().optional().allow(null).allow(''),
      firstName: Joi.string().required(),
      lastName: Joi.string().required(),
      middleName: Joi.string().optional().allow(null).allow(''),
      preferredName: Joi.string().optional().allow(null).allow(''),
      email: Joi.string()
        .email({ maxDomainSegments: 4, tlds: { allow: false } })
        .required()
        .pattern(
          new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
        ),
      gender: Joi.allow(
        'Male',
        'Female',
        'Non-binary',
        'Gender-diverse',
        'Transgender',
        'Different-identity',
      ).required(),
      mobile: Joi.string().length(9).required(),
      home: Joi.string().optional().allow(null).allow(''),
      dob: Joi.string().required(),
      internal: Joi.boolean().required(),
      ...((payload as any).medicare
        ? {
            medicare: Joi.string()
              .pattern(/^[2-6][0-9]{8}[1-9]$/)
              .required(),
          }
        : { medicare: Joi.string().optional().allow(null).allow('') }),
      ...((payload as any).medicare_reference
        ? {
            medicare_reference: Joi.string()
              .pattern(/^[1-9]$/)
              .required(),
          }
        : {
            medicare_reference: Joi.string().optional().allow(null).allow(''),
          }),
      ...((payload as any).medicareExpiry
        ? { medicareExpiry: Joi.string().required() }
        : { medicareExpiry: Joi.string().allow(null).allow('') }),
      dva: Joi.number().optional().allow(null).allow(''),
    },
    address: Joi.object()
      .keys({
        address_line_one: Joi.string().optional().allow(null).allow(''),
        address_line_two: Joi.string().optional().allow(null).allow(''),
        city: Joi.string().optional().allow(null).allow(''),
        state: Joi.string().optional().allow(null).allow(''),
        post_code: Joi.number().optional().allow(null).allow(''),
        street_number: Joi.string()
          .optional()
          .allow(null)
          .allow('')
          .allow('undefined'),
        street_name: Joi.string()
          .optional()
          .allow(null)
          .allow('')
          .allow('undefined'),
      })
      .optional(),

    emergency_contact_information: Joi.object()
      .keys({
        contact_name: Joi.string().optional().allow(null).allow(''),
        contact_number: Joi.string().optional().allow(null).allow(''),
        contact_relationship: Joi.string().optional().allow(null).allow(''),
        consent: Joi.boolean().optional(),
      })
      .optional(),
    ...((payload as any).prescriptions.length
      ? {
          prescriptions: Joi.array().items(
            Joi.object({
              id: Joi.number().optional().allow(null).allow(''),
              created_date: Joi.date().required(),
              quantity: Joi.string().required(),
              repeats: Joi.string().required(),
              interval: Joi.string().optional().allow(null).allow(''),
              eRxToken: Joi.string().optional().allow(null).allow(''),
              product: Joi.object({
                label: Joi.string().required(),
                value: Joi.alternatives()
                  .try(Joi.string(), Joi.number())
                  .required(),
              }).required(),
              doctor: Joi.object({
                label: Joi.string().optional().allow(null).allow(''),
                value: Joi.alternatives()
                  .try(Joi.string(), Joi.number())
                  .optional()
                  .allow(null)
                  .allow(''),
              }).optional(),
              dosage: Joi.string().optional().allow(null).allow(''),
            }),
          ),
        }
      : { prescriptions: Joi.array().items(Joi.object()).required().empty() }),
  });

  const { error } = obj.validate(payload);

  return error ? error.details : false;
};
